import script from "./WxLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./WxLogin.vue?vue&type=script&setup=true&lang=js"
script.__scopeId = "data-v-82148896"

export default script